import { Mic, Video, Volume2 } from 'lucide-react'

interface DeviceSelectorProps {
  audioInputDevices: MediaDeviceInfo[]
  audioOutputDevices: MediaDeviceInfo[]
  videoInputDevices: MediaDeviceInfo[]
  selectedAudioInputId: string | null
  selectedAudioOutputId: string | null
  selectedVideoInputId: string | null
  onAudioInputChange: (deviceId: string) => void
  onAudioOutputChange: (deviceId: string) => void
  onVideoInputChange: (deviceId: string) => void
}

export function DeviceSelector({
  audioInputDevices,
  audioOutputDevices,
  videoInputDevices,
  selectedAudioInputId,
  selectedAudioOutputId,
  selectedVideoInputId,
  onAudioInputChange,
  onAudioOutputChange,
  onVideoInputChange,
}: DeviceSelectorProps) {
  return (
    <div className="space-y-4">
      {/* Microphone */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-[var(--text-muted)]">
          <Mic size={16} />
          Microphone
        </label>
        <select
          value={selectedAudioInputId || ''}
          onChange={(e) => onAudioInputChange(e.target.value)}
          className="w-full bg-[var(--bg-element)] border border-[var(--border)] text-[var(--text-main)] px-3 py-2 rounded-lg focus:outline-none focus:border-[var(--primary)]"
        >
          {audioInputDevices.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Microphone ${device.deviceId.slice(0, 8)}`}
            </option>
          ))}
        </select>
      </div>

      {/* Speaker */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-[var(--text-muted)]">
          <Volume2 size={16} />
          Speaker
        </label>
        <select
          value={selectedAudioOutputId || ''}
          onChange={(e) => onAudioOutputChange(e.target.value)}
          className="w-full bg-[var(--bg-element)] border border-[var(--border)] text-[var(--text-main)] px-3 py-2 rounded-lg focus:outline-none focus:border-[var(--primary)]"
        >
          {audioOutputDevices.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Speaker ${device.deviceId.slice(0, 8)}`}
            </option>
          ))}
        </select>
      </div>

      {/* Camera */}
      <div className="space-y-2">
        <label className="flex items-center gap-2 text-sm font-medium text-[var(--text-muted)]">
          <Video size={16} />
          Camera
        </label>
        <select
          value={selectedVideoInputId || ''}
          onChange={(e) => onVideoInputChange(e.target.value)}
          className="w-full bg-[var(--bg-element)] border border-[var(--border)] text-[var(--text-main)] px-3 py-2 rounded-lg focus:outline-none focus:border-[var(--primary)]"
        >
          {videoInputDevices.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Camera ${device.deviceId.slice(0, 8)}`}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
